/* eslint-disable */
// Copyright 2021 The Casdoor Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import React from "react";
import styled from "styled-components";
import LoginPage from "./LoginPage";
import { authConfig } from "./Auth";
import Carousel from "./components/carousel";
import HeaderTitle from "./components/headerTitle";
class SelfLoginPage extends React.Component {
  constructor(props) {
    super(props);
    import("../ManagementPage");
  }
  render() {
    return (
      <Warper>
        <div className="carousel">
          <Carousel />
        </div>
        <div className="login">
          <HeaderTitle />
          <LoginPage
            type={"login"}
            mode={"signin"}
            applicationName={authConfig.appName}
            {...this.props}
          />
        </div>
      </Warper>
    );
  }
}

const Warper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  .login {
    width: 40%;
    height: 100%;
    background: #f8f8f8;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .carousel {
    width: 60%;
    height: 100%;
    background: radial-gradient(50% 50% at 50% 50%, #ebeff2 0%, #e5e8ef 100%);
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export default SelfLoginPage;
